import { FC } from 'react'
import { AppBar, Toolbar, ColorfulBar, Stack, useMediaQuery } from '@maas-components/core'
import { Theme } from '@maas-components/styles'
import { useMaasKeycloak } from '@maas-tools/keycloak'
import { Link } from 'react-router-dom'
import { KEYCLOAK_LOGOUT_REDIRECT_URL, KEYCLOAK_LOGOUT_URL } from 'common/constants/env'
import { ERoute } from 'common/entities/routes'
import { getProfilesStore, useRolesStore } from 'common/store/roles'
import { MagaluWordmark } from 'components/Logo'
import { TDrawerOptions } from 'components/SideBar/types'
import AppProfile from '../AppProfile'
import useStyles from './style'

export interface TAppHeaderProps {
  options: TDrawerOptions
  setOptions: (options: TDrawerOptions) => void
}

const AppHeader: FC<TAppHeaderProps> = () => {
  const { keycloak } = useMaasKeycloak()
  const { profiles } = useRolesStore(getProfilesStore)
  const description = profiles.map(profile => profile.description).join(', ')
  const name: string = keycloak?.tokenParsed?.name || ''
  const email: string = keycloak?.tokenParsed?.email || ''
  const isDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const isDownXS = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'))

  const classes = useStyles()

  const height = () => {
    if (isDownXS) return 60
    if (isDownSM) return 68
    return 80
  }

  const logout = () => {
    if (KEYCLOAK_LOGOUT_URL) {
      const url = KEYCLOAK_LOGOUT_URL + encodeURIComponent(KEYCLOAK_LOGOUT_REDIRECT_URL)
      window.location.replace(url)
      return
    }
    keycloak.logout({ redirectUri: KEYCLOAK_LOGOUT_REDIRECT_URL })
  }

  return (
    <AppBar elevation={1} className={classes.header}>
      <ColorfulBar disableGutters />
      <Toolbar data-testid="toolbar" style={{ height: height() }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" justifyContent="flex-start" alignItems="center">
            <Link to={ERoute.HOME} title="Proteção de Marcas" data-testid="LogoLinkHome">
              <MagaluWordmark className={classes.logo} />
            </Link>
          </Stack>
          <Stack direction="row" justifyContent="flex-end">
            <AppProfile
              name={name}
              email={email}
              onLogout={logout}
              enableUserInfo
              description={description}
            />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

export default AppHeader
